/* istanbul ignore file */

export const domain = 'content';
